import { MatchesAddScreenP, MatchesAddScreenPropsP } from './screen_p';
import { useToast } from '@app/core/notifications';
import { AuditMatch } from '@mi-front/core';
import { auditSpotAuditSpotMatchesCreateManual } from '@mi-front/api-v2';
import { useIntl } from 'react-intl';

type Props = Pick<MatchesAddScreenPropsP, 'station' | 'datetime' | 'show' | 'onHide'> & {
  onSuccess?: (match: AuditMatch) => unknown;
};

/**
 * Modal flow to create a manual spot match via api-v2.
 */
export function MatchesAddPage(p: Props) {
  const { station, datetime, show, onHide, onSuccess } = p;
  const { $t } = useIntl();
  const { notifySuccess, notifyError } = useToast();

  return (
    <MatchesAddScreenP
      station={station}
      datetime={datetime}
      submitFn={async (data) => {
        try {
          const match = (await auditSpotAuditSpotMatchesCreateManual(
            {
              audioId: data.audioId,
              datetime: data.datetime,
              score: data.score,
              playedDuration: data.playedDuration,
            },
            { station: station.id },
          )) as AuditMatch;

          notifySuccess(
            $t({
              id: 'audit.matchesAdd.created',
              defaultMessage: 'Match manual creado',
            }),
          );

          onHide();

          onSuccess?.(match);
        } catch (err) {
          notifyError(
            $t({
              id: 'audit.matchesAdd.createError',
              defaultMessage: 'Error al crear la coincidencia',
            }),
          );

          throw err;
        }
      }}
      show={show}
      onHide={onHide}
    />
  );
}
